import Axios from 'axios';
import firebase from '../Firebase/firebase';
// import { toast } from 'react-toastify';

const axios = Axios.create();

axios.interceptors.request.use(async(config) => {
  // const token = localStorage.getItem('accessToken');
  const token = await firebase.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  error => {
    if(error.response && error.response.status === 401){
      firebase.logout()
    }
    // toast.error('Failed to proceed request');
    return Promise.reject(error);
  }
);

export default axios;
